import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'
import auth from './auth'
import components from './components'
import filters from './filters'
import directives from './directives'
import {DefaultMixins, AuthMixins} from './mixins'

Vue.prototype.$isBooth = document.location.hostname === "project-ikigai.herokuapp.com";

import AnimeJS from './utils/anime'
Vue.use(AnimeJS)
import ToneJS from './utils/tone'
Vue.use(ToneJS)
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import LedController from './utils/leds'
Vue.use(LedController)
import SurveyHelper from './utils/surveyHelper'
Vue.use(SurveyHelper)
import Vuetify from 'vuetify'
Vue.use(Vuetify)

Vue.config.productionTip = false

// register components
for (let key in components) Vue.component(key, components[key])

// filters
Object.keys(filters).forEach((name) => {
	Vue.filter(name, filters[name])
})

// directive
Object.keys(directives).forEach((name) => {
	Vue.directive(name, directives[name])
})

// mixins
Vue.mixin(AuthMixins)
Vue.mixin(DefaultMixins)

// kick off the app
auth.init().then(() => {
	new Vue({
		store,
		router,
		...App
	}).$mount('#app')
})

